import React, { useState, useEffect } from "react";
import { remove } from "lodash";
import ToDoCard from "../../components/ToDoCard";
import Empty from "../../components/error/Empty";
import { ReactComponent as ToDoTask } from "../../assets/svg/todo.svg";
import { Box, Drawer, IconButton, Tab, Tabs } from "@mui/material";
import ToDoCountBadge from "../../components/ToDoCountBadge";
import { TWO_COLOR_SHADES } from "../../theme/shades";
import { getToDoItems, updateToDoReadTime } from "../../services/dataService";
import { TODO_TASK_LOAD } from "../../store/ActionType";
import { dispatcher } from "../../store/helper";

function ToDoDrawer() {
  const pettle = TWO_COLOR_SHADES["skyblue"];
  const [originalToDo, setOriginalToDo] = useState([]);
  const [toDoDrawer, setToDoDrawer] = useState(false);
  const [selectedTodo, setSelectedTodo] = useState([]);
  const [selectedTab, setSelectedTab] = useState("All");
  const [toDoTasks, setToDoTasks] = useState([]);

  const getToDos = async () => {
    try {
      const response = await getToDoItems();
      setToDoTasks(response.data);
      setOriginalToDo(response.data);
    } catch (error) {
      dispatcher(TODO_TASK_LOAD, []);
      setToDoTasks([]);
    }
  };

  useEffect(() => {
    getToDos();
  }, []);

  const toggleToDoDrawer = () => {
    setToDoDrawer(!toDoDrawer);
    async function updateLastToDoRead() {
      await updateToDoReadTime();
    }
    getToDos();
    updateLastToDoRead();
  };

  const handleTabChange = (e, newValue) => {
    setSelectedTab(newValue);

    if (newValue !== "All") {
      let todoArray = [];
      for (const item of originalToDo) {
        if (item.ModuleName === newValue) {
          todoArray.push(item);
        }
      }
      setToDoTasks(todoArray);
    } else {
      setToDoTasks(originalToDo);
    }
  };
  return (
    <>
      <IconButton
        color="info"
        sx={{
          mr: 1,
          backgroundColor: pettle.light,
          height:"30px",
          width:"30px"
        }}
        onClick={toggleToDoDrawer}
      >
        <ToDoCountBadge />
      </IconButton>
      <Drawer
        anchor={"right"}
        open={toDoDrawer}
        onClose={toggleToDoDrawer}
        PaperProps={{
          sx: {
            width: 380,
            p: 2,
            boxShadow: "none",
            backgroundColor: "background.default",
          },
        }}
      >
        <Tabs
          sx={{
            minHeight: "42px",
          }}
          value={selectedTab}
          onChange={handleTabChange}
        >
          <Tab value={"All"} sx={{ p:"10px" }}label="All" />
          <Tab value={"Purchase Order"} label="Purchase Order" />
          <Tab value={"GRN Order"} label="GRN" />
          <Tab value={"QC Screen"} label="Quality check" />
        </Tabs>

        {toDoTasks.length !== 0 &&
          toDoTasks.map((item, index) => {
            return (
              <Box key={index}>
                <ToDoCard
                  todo={item}
                  setCheckedBox={(event) => {
                    if (event.target.checked === true) {
                      setSelectedTodo([...selectedTodo, item]);
                    } else {
                      var newArray = remove(selectedTodo, (e) => {
                        return e !== item;
                      });
                      setSelectedTodo(newArray);
                    }
                  }}
                />
              </Box>
            );
          })}
        {toDoTasks.length === 0 && (
          <Empty title={"No pending work"} svgFile={<ToDoTask />} />
        )}
      </Drawer>
    </>
  );
}

export default ToDoDrawer;
